export const iconFontAwesomePoliticalScaleUnbalanced = (
	<i className="fa-solid fa-scale-unbalanced"></i>
);
